import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs, useSlots } from "vue";
import SvgIcon from "./SvgIcon/SvgIcon.vue";
import SharedSpinner from "./SharedSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SharedButton',
  props: {
    variant: { default: "primary" },
    dark: { type: Boolean },
    disabled: { type: Boolean },
    isLoading: { type: Boolean },
    to: null,
    orchestratorLink: { type: Boolean },
    type: { default: "button" },
    prependIcon: null,
    appendIcon: null,
    iconSize: { default: "5" },
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { variant: "primary" | "secondary" | "prominent" | "text", dark?: boolean, disabled?: boolean, isLoading?: boolean, to?: object | string, orchestratorLink?: boolean, type: "button" | "submit" | "reset" | undefined, prependIcon?: string, appendIcon?: string, iconSize: string, small?: boolean }



const isDisabled = computed(() => props.disabled || props.isLoading);

const hasSlot = computed(() => !!useSlots().default);

const isPrimary = computed(() => props.variant === "primary");
const isSecondary = computed(() => props.variant === "secondary");
const isProminent = computed(() => props.variant === "prominent");
const isText = computed(() => props.variant === "text");

const isLink = computed(() => props.to || useAttrs().href);

return { __sfc: true,props, isDisabled, hasSlot, isPrimary, isSecondary, isProminent, isText, isLink, SvgIcon, SharedSpinner }
}

})